// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1063":"55153c84","3302":"f3e88c63","5573":"55153c84","7007":"55153c84","7954":"55153c84","9884":"ef5225e4"}[chunkId] + ".chunk.css";
};